(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-product"] && !Shopify.designMode) return;
  try {
    
function setupTideWinkProduct(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const variants=JSON.parse(root.querySelector('[data-tw-variants]').textContent),labels=JSON.parse(root.querySelector('[data-tw-labels]').textContent),master=root.querySelector('[data-tw-variant]'),options=[...root.querySelectorAll('[data-tw-option]')],button=root.querySelector('[data-tw-submit]'),sale=root.querySelector('[data-tw-sale]'),compare=root.querySelector('[data-tw-compare]'),status=root.querySelector('[data-tw-status]');
 function show(variant,updateUrl){button.disabled=!variant?.available;button.textContent=variant?.available?labels.add:labels.sold;status.textContent=variant?'':labels.unavailable;if(variant){master.value=String(variant.id);sale.textContent=variant.price;compare.textContent=variant.compareAt;compare.hidden=!variant.onSale;options.forEach((o,i)=>o.value=variant.options[i]);if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}}else{master.selectedIndex=-1;}}
 if(options.length){root.querySelector('[data-tw-options]').hidden=false;root.querySelector('[data-tw-master]').hidden=true;options.forEach(o=>o.addEventListener('change',()=>show(variants.find(v=>v.options.every((x,i)=>x===options[i].value)),true)));}else master.addEventListener('change',()=>show(variants.find(v=>String(v.id)===master.value),true));
 show(variants.find(v=>String(v.id)===master.value),false);
 root.querySelector('form').addEventListener('submit',event=>{const variant=variants.find(v=>String(v.id)===master.value);if(!variant?.available){event.preventDefault();status.textContent=labels.unavailable;}});
}
document.querySelectorAll('[data-tw-product]').forEach(setupTideWinkProduct);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-tw-product]').forEach(setupTideWinkProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-work-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.tw-mobile__links a');if(link)link.closest('details').open=false;});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.tw-mobile[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();
})();
